<!--
 * @Description: 
 * @Author: 琢磨先生
 * @Date: 2022-05-09 10:58:42
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2022-12-02 09:45:56
-->
<template>
  <el-dialog
    v-model="drawer"
    :title="title"
    direction="rtl"
    width="800px" 
    @closed="onClosed"
    :close-on-click-modal="false"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="140px">
      <el-form-item label="名称" prop="name">
        <el-col :span="14">
          <el-input v-model="form.name" placeholder="请输入床型名称"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="可睡人数" prop="number">
        <el-col :span="10">
          <el-input v-model="form.number" placeholder="请输入正整数"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="onSubmit"
          :disabled="loading"
          :loading="loading"
          >确定</el-button
        >
        <!-- <el-button @click="cancelClick" :disabled="loading">取消</el-button> -->
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      drawer: false,
      title: "编辑",
      form: {},
      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        number: [
          {
            required: true,
            message: "请输入人数",
            trigger: "blur",
          },
          {
            pattern: "^[1-9]$",
            message: "正整数",
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: ["item"],
  emits:['close','success'],
  watch: {
    item: {
      handler() {
        if (this.item) {
          this.drawer = true;
          this.title = "新增床型";
          this.form = Object.assign({}, this.item);
          if (this.item.id) {
            this.title = "修改床型";
          }
        }
      },
    },
  },

  methods: {
    /**
     * 提交保存
     */
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http
            .post("/admin/v1/bed/edit", this.form)
            .then((res) => {
              this.loading = false;
              if (res.code == 0) {
                this.drawer = false;
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                // if (this.reload) {
                //   this.reload();
                // }
                this.$emit('success');
              }
            })
            .cath(() => {
              this.loading = false;
            });
        }
      });
    },
    /**
     * 取消
     */
    onClosed() {
      this.$emit('close');
    },
    /**
     * 规格选择变动
     */
    sizeChange(val) {
      console.log(val);
    },
  },
};
</script>